<div class="tabs">
    <div class="tab">
        <button (click)="tabs.active ='titles'" [ngClass]="{'active':tabs.active === 'titles'}">Header</button>
    </div>
    <div class="tab">
        <button (click)="tabs.active ='topbar'" [ngClass]="{'active':tabs.active === 'topbar'}">Topbar</button>
    </div>
    <div class="tab">
        <button (click)="tabs.active ='externalbtn'" [ngClass]="{'active':tabs.active === 'externalbtn'}">Link</button>
    </div>
    <div class="tab">
        <button (click)="tabs.active ='logofavicon'" [ngClass]="{'active':tabs.active === 'logofavicon'}">Logo / Favicon</button>
    </div>
</div>
<div class="tabs-content">
    <app-sbeditor-tool-titles [hidden]="tabs.active !== 'titles'" #titles (exportTool)="getTool($event,'titles')"></app-sbeditor-tool-titles>
    <app-sbeditor-tool-topbar [hidden]="tabs.active !== 'topbar'" #topbar (exportTool)="getTool($event,'topbar')"></app-sbeditor-tool-topbar>
    <app-sbeditor-tool-externalbtn [hidden]="tabs.active !== 'externalbtn'" #externalbtn (exportTool)="getTool($event,'externalbtn')"></app-sbeditor-tool-externalbtn>
    <app-sbeditor-tool-logofavicon [hidden]="tabs.active !== 'logofavicon'" #logofavicon (exportTool)="getTool($event,'logofavicon')"></app-sbeditor-tool-logofavicon>
</div>

<div class="tabs-bottom">
    <button class="btn-secondary-action" (click)="save()">Aplicar cambios</button>
</div>